import { Grid } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import SettingsIcon from '@material-ui/icons/Settings'
import React, { useContext } from 'react'
import { compose } from 'recompose'
import envGet from '../../Support/Env/Get/EnvGet.support'
import Modal from '../Modal/Modal.component'
import NotificationsList from '../NotificationsList/NotificationsList.component'
import NotificationsSettings from '../NotificationsSettings/NotificationsSettings.component'
import NotificationsModalStyles from './styles'
import { useDispatch, useSelector } from 'react-redux'
import ServicesContext from 'Contexts/Services/Services.context'
import hitGTM from 'State/Store/UI/Actions/GTM.action'
import { UI_NOTIFICATIONS_NOTIFICATIONS_DIALOG_SETTINGS_ICON } from 'State/Store/UI/UI.types'
import NotificationActionCreatorsMapping from 'State/Store/Notification/NotificationActionCreatorCenter'
import createNotificationSelector from 'State/Store/Notification/Notification.selector'
import { WithGlobalStylesProps } from 'types/styles/WithGlobalStylesProps';
import { withGlobalStyles } from 'Support/Theme/CreateInjectableStyles/withGlobalStyles'

const REACT_APP_BORAL_FEATURE_TOGGLE_NOTIFICATIONS_SETTINGS = envGet({
  key: `REACT_APP_BORAL_FEATURE_TOGGLE_NOTIFICATIONS_SETTINGS`,
}) === `true`

interface Props {
  any?: any,
}
type FProps = Props & WithGlobalStylesProps<typeof NotificationsModalStyles>

const NotificationsModalComp = (props: FProps) => {
  const {
    classes,
  } = props
  const dispatch = useDispatch()
  const { notificationService } = useContext(ServicesContext)
  const handleShowSettings = () => {
    dispatch(hitGTM(UI_NOTIFICATIONS_NOTIFICATIONS_DIALOG_SETTINGS_ICON))
    dispatch(NotificationActionCreatorsMapping.toggleNotificationSettings())
  }
  const handleClose = () => {
    notificationService.markAllRead()
    dispatch(NotificationActionCreatorsMapping.closeNotificationModal())
  }
  const { open, settingsOpen } = useSelector(createNotificationSelector)
  const handleHideSettings = () => {
    dispatch(NotificationActionCreatorsMapping.toggleNotificationSettings())
  }
  return (
    <Modal
      fullWidth
      content={
        settingsOpen && REACT_APP_BORAL_FEATURE_TOGGLE_NOTIFICATIONS_SETTINGS ? (
          <NotificationsSettings />
        ) : (
          <NotificationsList />
        )
      }
      maxWidth='sm'
      onClose={handleClose}
      open={open}
      title={
        <Grid container>
          <Grid item xs={12}>
            { settingsOpen ? `Notifications Settings` : `Notifications` }
          </Grid>
        </Grid>
      }
      icon={settingsOpen ? <ArrowBackIcon /> : null}
      rightHeading={
        settingsOpen || !REACT_APP_BORAL_FEATURE_TOGGLE_NOTIFICATIONS_SETTINGS ? null : (
          <Grid container justify='flex-end'>
            <Grid item>
              <IconButton aria-label='Menu' color='inherit' onClick={handleShowSettings} >
                <SettingsIcon />
              </IconButton>
            </Grid>
          </Grid>
        )
      }
      onIconClick={settingsOpen && REACT_APP_BORAL_FEATURE_TOGGLE_NOTIFICATIONS_SETTINGS ? handleHideSettings : null}
    />
  )
}

const NotificationsModal = compose<FProps, Props>(
  withGlobalStyles(NotificationsModalStyles),
)(NotificationsModalComp)

export default NotificationsModal
